const form = {
  formId: "new-user-form",
  formField: {
    taxId: {
      name: "taxId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label: "Tên tổ chức cá nhân",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức cá nhân:",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    creator: {
      name: "creator",
      label: "Người lập biểu",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người lập biểu",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    lastTime: {
      name: "lastTime",
      label: "Kỳ báo cáo cuối cùng:",
      type: "text",
    },
    changePosition: {
      name: "changePosition",
      label: "Chuyển vị trí:",
      type: "text",
    },
    releaseDate: {
      name: "releaseDate",
      label: "Ngày Lập báo cáo",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày lập báo cáo",
    },
    representative: {
      name: "representative",
      label: "Người đại diện theo pháp luật",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người đại diện",
    },
  },
};
const AppendixForm = {
  formIdAppendix: "new-user-form",
  formFieldAppendix: {
    taxIdAppendix: {
      name: "taxId",
      label: "2.Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyNameAppendix: {
      name: "conpanyName",
      label: "1.Tên tổ chức cá nhân",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức cá nhân:",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    releaseDateAppendix: {
      name: "releaseDate",
      label: "Ngày Lập báo cáo",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày lập báo cáo",
    },
    representativeAppendix: {
      name: "representative",
      label: "Người đại diện theo pháp luật",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người đại diện",
    },
  },
};

const AppendixForm1 = {
  formIdAppendix1: "new-user-form",
  formFieldAppendix1: {
    taxIdAppendix1: {
      name: "taxId",
      label: "2.Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyNameAppendix1: {
      name: "conpanyName",
      label: "1.Tên tổ chức cá nhân",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức cá nhân:",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    releaseDateAppendix1: {
      name: "releaseDate",
      label: "Ngày Lập báo cáo",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày lập báo cáo",
    },
    representativeAppendix1: {
      name: "representative",
      label: "Người đại diện theo pháp luật",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người đại diện",
    },
  },
};

export { form, AppendixForm, AppendixForm1 };
